import Config from "../../../Config";
import Listing_screen from "../proposal_screen.js/listing_screen";
import React from "react";
import { withRouter } from "react-router-dom";

class BusinessOpportunitiesUpcomingScreenV2 extends React.Component {
  constructor(props) {
    super(props);
  }

  stateMPartFromDashboard() {
    return this.state.part;
  }

  componentDidMount() {}

  render() {
    return (
      <Listing_screen
        listId={"df-business-oppo-list"} //To define which list this is loading for
        countId={"df-business-oppo-count"} //To define which count to retrieve
        module={"businessOpportunity-upcoming"} //To define which module this list is for
        detailRoute={Config.routes.generic.businessOpportunityUpcoming} //Route to detail screen
        listingTitle={"Business Opportunities"} //Title of listing
        part={"event"}
        dateRange={"upcoming"}
      />
    );
  }
}

export default withRouter(BusinessOpportunitiesUpcomingScreenV2);
